module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/gacha_1-4741be9a15c28fd0b4b9c12c5f68f0d4.png";